import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, Space, theme } from 'antd';
import { AdminSurveyQuestionDetailDto } from '@wellverse/shared-ts';
import { Field } from '../../components/Field';

export const SurveyQuestionShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<AdminSurveyQuestionDetailDto>({ resource: 'survey-questions' });
  const item = queryResult?.data?.data;

  if (!item) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="survey-questions">
      <div style={{ padding: '8px 0' }}>
        <Field label="Question Key">{item.questionKey}</Field>
        <Field label="Question Text">{item.questionText}</Field>
        <Field label="Type">{item.type}</Field>
        <Field label="Order Index">{item.orderIndex}</Field>
        <Field label="Required">
          <Tag
            style={{
              borderColor: item.isRequired ? '#3ecf8e' : '#898989',
              color: item.isRequired ? '#3ecf8e' : '#898989',
              background: item.isRequired ? '#3ecf8e15' : '#89898915',
              borderRadius: 9999,
              padding: '2px 12px',
              fontWeight: 500,
            }}
          >
            {item.isRequired ? 'Required' : 'Optional'}
          </Tag>
        </Field>
        <Field label="Active">
          <Tag
            style={{
              borderColor: item.isActive ? '#3ecf8e' : '#898989',
              color: item.isActive ? '#3ecf8e' : '#898989',
              background: item.isActive ? '#3ecf8e15' : '#89898915',
              borderRadius: 9999,
              padding: '2px 12px',
              fontWeight: 500,
            }}
          >
            {item.isActive ? 'Active' : 'Inactive'}
          </Tag>
        </Field>
        <Field label="Validation">
          <pre style={{ background: token.colorBgContainer, padding: 12, borderRadius: 8 }}>
            {item.validation ? JSON.stringify(item.validation, null, 2) : '—'}
          </pre>
        </Field>
        <Field label="Options">
          {item.options && item.options.length > 0 ? (
            <Space direction="vertical" style={{ width: '100%' }}>
              {item.options.map((opt) => (
                <div key={opt.id} style={{ background: token.colorBgContainer, padding: 12, borderRadius: 8 }}>
                  <div><strong>{opt.label}</strong> ({opt.value})</div>
                  <div style={{ color: token.colorTextSecondary, fontSize: 12 }}>Order: {opt.orderIndex}{opt.icon ? ` · Icon: ${opt.icon}` : ''}</div>
                </div>
              ))}
            </Space>
          ) : (
            '—'
          )}
        </Field>
      </div>
    </Show>
  );
};
